//import { UserRole, UserStatus } from './enums';
import { Subscriber } from './subscriber'; // تأكد من وجود هذا الملف والنوع
// هذا الملف يجب أن يعرف كائن المستخدم الأساسي
export enum UserRole {
  ADMIN = "admin",
  EDITOR = "editor",
  LAWYER = "lawyer",
  TRAINEE = "trainee",
  GUEST = "guest",
  SUBSCRIBER ="subscriber"
}

export enum UserStatus {
  ACTIVE = "active",
  INACTIVE = "inactive",
  SUSPENDED = "suspended",
   PENDING_APPROVAL = "pending_approval"
}


// 2. تعريف واجهة للبيانات الإضافية عند التسجيل
export interface RegistrationPayload {
  registrationType: 'subscriber' | 'trainee' | 'lawyer';
  name?: string; // اسم المشترك الجديد
  qualification?: string; // مؤهل المشترك الجديد
  graduation_year?: number; // سنة تخرج المشترك الجديد
  registrationId?: string; // رقم القيد للمتدرب أو المحامي الحالي
  
}
export interface User {
  id: number;
  email: string; // هذا هو بريد تسجيل الدخول
  name: string;
  phone: string;
  role: UserRole;
  status: UserStatus;
  created_at: string;
  
  registration_payload: {
    registrationType: 'lawyer' | 'trainee' | 'subscriber';
    registrationId?: string;
    name?: string; // أضفنا الاسم هنا لتسهيل العرض
  };

  // !! الخطوة 2: إضافة العلاقة الاختيارية subscriber !!
  subscriber?: Subscriber;
}
